import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import eSim from "@static/img/manageSim/esim.png";
import { useStyle } from "@features/ManageSim/css/eSimBannerStyle";
import { useState } from "react";
import { ESimActivationModal } from "@features/ManageSim/ESimActivationModal";
import { IServiceWithESimToActivate } from "@features/ManageSim/interface/IServiceWithESimToActivate";

interface IParams {
    serviceWithESimToActivateList: IServiceWithESimToActivate[];
}

export const ESimBanner = (props: IParams) => {
    const { serviceWithESimToActivateList } = props;
    const { t } = useTranslation(["sim", "common"]);

    const { classes } = useStyle();

    const [isESimActivationModalOpen, setIsESimActivationModalOpen] = useState(false);

    return (
        <>
            <Card className={classes.eSim} elevation={2}>
                <CardContent className={classes.eSimContent}>
                    <Box alignItems="center" display="flex">
                        <img alt="eSIM" height={40} src={eSim} />
                        <Typography className={classes.eSimTitle}>{t("sim:completeESimInstallation")}</Typography>
                    </Box>
                    <Button
                        color="secondary"
                        size="large"
                        type="button"
                        variant="contained"
                        onClick={() => setIsESimActivationModalOpen(true)}
                    >
                        {t("common:activate")}
                    </Button>
                </CardContent>
            </Card>
            {isESimActivationModalOpen && (
                <ESimActivationModal
                    isModalOpen={isESimActivationModalOpen}
                    serviceWithESimToActivateList={serviceWithESimToActivateList}
                    onClose={() => setIsESimActivationModalOpen(false)}
                />
            )}
        </>
    );
};
